export default "__VITE_ASSET__2faee669__"